import { useTranslation } from 'react-i18next';
import { TableCell } from '@anytag/shared-atoms';
import { ColumnDef } from '@tanstack/react-table';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { formatIntNumber, formatPercent } from '@anytag/shared-utils';
import { InstagramCompareFeedPost, InstagramFeedPostSortField } from '@anytag/graphql';

export const useAnalyticsInstagramComparePostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InstagramCompareFeedPost>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Post'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.thumbNail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'engagement',
      header: t<string>('HeaderColumn.Engagement'),
      meta: {
        align: 'right',
        help: t<string>('Tooltip.EngagementHelp'),
        sortField: InstagramFeedPostSortField.ENGAGEMENT
      },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.engagement)} />
    },
    {
      accessorKey: 'engagementRate',
      header: t<string>('HeaderColumn.Engagement Rate by Followers'), // TODO: Renat will change it later
      meta: {
        align: 'right',
        help: t<string>('Tooltip.EngagementRateHelp'),
        sortField: InstagramFeedPostSortField.ENGAGEMENT_RATE
      },
      cell: ({ row }) => <TableCell.Number value={formatPercent(row.original.engagementRate, false, 2)} unit="%" />
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: {
        align: 'right',
        help: t<string>('Tooltip.LikeHelp'),
        sortField: InstagramFeedPostSortField.LIKE
      },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.likes)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: {
        align: 'right',
        help: t<string>('Tooltip.CommentHelp'),
        sortField: InstagramFeedPostSortField.COMMENT
      },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { help: t<string>('Tooltip.PostDateHelp'), sortField: InstagramFeedPostSortField.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
